import axios from "../../../util/axios";

const PREFIX_URI = "/basedata/crm/leave/stat";

/**
 * 请假统计页接口
 */
export default {
    /** 查询请假统计报表（只统计已通过的单据） */
    report: (data) => axios.get({url: `${PREFIX_URI}/report`, data}),
}
